import type { MagentoProductTypeName, MagentoStockStatus } from "@jti/magento-types";

type StockStatusVariant = {
  product: { sku: string; stock_status: string };
};

type StockStatusProductData = {
  __typename?: MagentoProductTypeName | string;
  stock_status?: MagentoStockStatus | string;
  variants?: StockStatusVariant[];
};

const getConfigurableProductIsInStock = (variants: StockStatusVariant[] | undefined, currentVariantSku: string) => {
  const variant = variants?.find(({ product }) => product.sku === currentVariantSku);

  return (variant?.product.stock_status as MagentoStockStatus) === "IN_STOCK";
};

export const getIsInStock = (currentVariantSku: string, data?: StockStatusProductData): boolean => {
  const { __typename = "", stock_status = "", variants } = data ?? {};

  if ((__typename as MagentoProductTypeName) === "ConfigurableProduct") {
    return getConfigurableProductIsInStock(variants, currentVariantSku);
  }

  return (stock_status as MagentoStockStatus) === "IN_STOCK";
};
